<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="8">
        <h1 class="font-weight-bolder mb-0">SMS Campaigns</h1>
      </b-col>
      <b-col cols="4" class="text-right">
        <b-link :to="{ name: 'marketing-sms-campaigns-new' }">
          <b-button size="md" variant="primary" @click="showModalPromotions">
            <feather-icon icon="PlusIcon" />
            <span class="text-lg text-nowrap" style="margin-left: 4px"
              >Create SMS Campaign</span
            >
          </b-button>
        </b-link>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="6" md="3">
        <span class="d-block text-center">Subscribed Users</span>
        <span class="d-block text-center">12,450</span>
        <span class="d-block text-center">Current opt-in users</span>
      </b-col>
      <b-col cols="6" md="3">
        <span class="d-block text-center">Open Rate</span>
        <span class="d-block text-center">92%</span>
        <span class="d-block text-center">Last 30 days</span>
      </b-col>
      <b-col cols="6" md="3">
        <span class="d-block text-center">Unsubscribed</span>
        <span class="d-block text-center">320</span>
        <span class="d-block text-center">Last 30 days</span>
      </b-col>
      <b-col cols="6" md="3">
        <span class="d-block text-center">Messages Sent </span>
        <span class="d-block text-center">38,200</span>
        <span class="d-block text-center">Last 30 days</span>
      </b-col>
    </b-row>

    <b-row>
      <b-table
        :items="items"
        :fields="tableColumns"
        responsive
        show-empty
        primary-key="id"
        thead-class="text-nowrap"
        class="mt-2"
      >
        <!-- <template #empty>
                <div v-if="list.loading" class="text-center text-dark my-2">
                  <p>Loading... Please wait</p>
                </div>
        
                <div
                  v-else-if="!list.loading && fetchUsers.length === 0"
                  class="text-center text-dark my-2"
                >
                  No matching records found
                </div>
              </template> -->
        <template #cell(campaignName)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              {{ item.campaignName }}
            </div>
          </b-media>
        </template>
        <template #cell(status)="{ item }">
          <b-media vertical-align="center">
            <div
              class="text-white bg-success d-flex rounded justify-content-center align-items-center font-weight-bolder"
              style="padding: 2px 4px; width: fit-content"
            >
              {{ item.status }}
            </div>
          </b-media>
        </template>

        <template #cell(startDate)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              {{ item.startDate }}
            </div>
          </b-media>
        </template>

        <template #cell(endDate)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              {{ item.endDate }}
            </div>
          </b-media>
        </template>
        <template #cell(recipients)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              {{ item.recipients }}
            </div>
          </b-media>
        </template>
        <template #cell(openRate)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              {{ item.openRate }}
            </div>
          </b-media>
        </template>
        <template #cell(unsubs)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              {{ item.unsubs }}
            </div>
          </b-media>
        </template>
        <template #cell(promo)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              {{ item.promo }}
            </div>
          </b-media>
        </template>

        <template #cell(actions)>
          <b-media vertical-align="center">
            <div class="d-flex align-items-center">
              <b-button size="sm" variant="outline-secondary" class="mr-1">
                Edit
              </b-button>
              <b-button size="sm" variant="outline-primary" class="mr-1">
                View
              </b-button>
            </div>
          </b-media>
        </template>
      </b-table>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BLink,
  BAvatar,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BLink,
  },
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      option: "Last 30 days",
      startDate: "",
      endDate: "",
      options: [
        { label: "Last 30 days", value: "last30days" },
        { label: "Last 7 days", value: "last7days" },
        { label: "Last 90 days", value: "last90days" },
      ],
      items: [
        {
          campaignName: "Weekend Racing Promo",
          status: "Sent",
          startDate: "2025-06-14",
          endDate: "2025-06-15",
          recipients: "8,200",
          openRate: "94%",
          unsubs: "21",
          promo: "Deposit Match",
        },
        {
          campaignName: "NBA Playoffs	Scheduled",
          status: "Scheduled",
          startDate: "2025-06-21",
          endDate: "2025-06-21",
          recipients: "12,450",
          openRate: "--",
          unsubs: "--",
          promo: "Odds Boost",
        },
        {
          campaignName: "Winter Welcome	",
          status: "Draft",
          startDate: "2025-06-25",
          endDate: "2025-06-27",
          recipients: "10,000",
          openRate: "--",
          unsubs: "--",
          promo: "Free Bet",
        },
      ],
      tableColumns: [
        { key: "campaignName", label: "Campaign Name" },
        { key: "status", label: "Status" },
        { key: "startDate", label: "Start Date" },
        { key: "endDate", label: "End Date" },
        { key: "recipients", label: "Recipients" },
        { key: "openRate", label: "Open Rate" },
        { key: "unsubs", label: "Unsubs" },
        { key: "promo", label: "Promo" },
        { key: "actions", label: "Actions" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
